import { cn } from "@heroui/react";
import DemoAvatar from "./DemoAvatar";
import { resolveConversationPhoto } from "../hooks/demoUtils";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { Conversation, InboxDemoIcons } from "../data/types";

type ConversationItemProps = {
  conversation: Conversation;
  icons: InboxDemoIcons;
  selected: boolean;
  onSelect: (conversationId: string) => void;
};

export default function ConversationItem({
  conversation,
  icons,
  selected,
  onSelect,
}: ConversationItemProps) {
  const channelIcon = resolveDemoIcon(icons, conversation.channelKey);

  return (
    <button
      aria-current={selected ? "true" : undefined}
      className={cn(
        "flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left transition-[background-color] duration-150",
        selected
          ? "bg-content2"
          : "bg-transparent hover:bg-default-100",
      )}
      type="button"
      onClick={() => onSelect(conversation.id)}
    >
      <DemoAvatar
        initial={conversation.avatarInitial}
        name={conversation.name}
        src={resolveConversationPhoto(conversation)}
        tone={conversation.avatarTone}
      />
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="flex w-full items-center gap-2">
          <span className="min-w-0 flex-1 truncate text-sm font-medium leading-5 text-default-800">
            {conversation.name}
          </span>
          {conversation.timestamp ? (
            <span className="shrink-0 text-center text-xs leading-4 text-default-500">
              {conversation.timestamp}
            </span>
          ) : null}
        </span>
        <span className="flex w-full items-center gap-2">
          <span className="min-w-0 flex-1 truncate text-sm leading-5 text-default-700">
            {conversation.preview}
          </span>
          {channelIcon ? (
            <span className="flex size-4 shrink-0 items-center justify-center overflow-hidden">
              {channelIcon}
            </span>
          ) : null}
          {conversation.unread ? (
            <span className="inline-flex min-w-4 items-center justify-center rounded-full bg-[#006FEE] px-1 text-[10px] leading-4 text-white">
              {conversation.unread}
            </span>
          ) : null}
        </span>
      </span>
    </button>
  );
}
